import Vue from 'vue'

const state = Vue.observable({
  stack: []
})

let uid = 1

function open(type, props = {}, options = {}) {
  return new Promise((resolve, reject) => {
    state.stack.push({
      id: uid++,
      type,
      props,
      options,
      resolve,
      reject
    })
  })
}

function close(id, payload, useReject = false) {
  const index = state.stack.findIndex(item => item.id === id)
  if (index === -1) return

  const current = state.stack[index]
  state.stack.splice(index, 1)

  if (useReject) {
    current.reject(payload)
    return
  }

  current.resolve(payload)
}

function closeTop(payload, useReject = false) {
  const top = state.stack[state.stack.length - 1]
  if (!top) return
  close(top.id, payload, useReject)
}

export default {
  install(VueInstance) {
    VueInstance.prototype.$dialog = {
      state,
      open,
      close,
      closeTop
    }
  }
}
